import { render } from "./PurchaseTableDirector.vue?vue&type=template&id=b5ef9362"
import script from "./PurchaseTableDirector.vue?vue&type=script&lang=js"
export * from "./PurchaseTableDirector.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__